import * as types from "./types"

export const setProfileDetails = (data) => ({
    type: types.SET_PROFILE_DETAILS,
    payload: data
})